import { render, staticRenderFns } from "./InboundPutaway.vue?vue&type=template&id=8df3aa7c"
import script from "./InboundPutaway.vue?vue&type=script&lang=js"
export * from "./InboundPutaway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports